import { AnyAction } from "redux";

export enum Type {
  WEBSOCKET_CONNECTION_STATUS = "WEBSOCKET_CONNECTION_STATUS",
}

export interface IWebSocketConnectionStatus {
  type: Type.WEBSOCKET_CONNECTION_STATUS;
  isConnected: boolean;
}

export type Action = IWebSocketConnectionStatus | AnyAction;

export const setWebSocketConnectionStatus = (isConnected: boolean): IWebSocketConnectionStatus => {
  return {
    type: Type.WEBSOCKET_CONNECTION_STATUS,
    isConnected,
  };
};
